import { ref, computed, watch, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17ba17d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "aptoideMultiComponents"
};
const _hoisted_2 = {
  class: "blockBody"
};
const _hoisted_3 = {
  key: 0,
  class: "actions"
};
const _hoisted_4 = {
  key: 1,
  class: "error-msg"
};
import { cloneDeep, debounce } from 'lodash';
import { useRoute } from 'vue-router';
import { awaitWrap, filterOption, getNode, OK } from '@/common';
import { queryLangOption, translator } from '@/api/goodsSetting';
import { message } from 'ant-design-vue';
import { PlusCircleOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AptoideMultiComponents',
  props: {
    nameRule: {
      type: Object,
      default: () => {
        return {
          placeholder: '商品名称，最多30字符',
          maxLength: 30
        };
      }
    },
    desRule: {
      type: Object,
      default: () => {
        return {
          placeholder: '商品描述，最多45字符',
          maxLength: 45
        };
      }
    },
    filterItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 默认语言由后端 getPkgInfo 下发，前端不写死具体语言码
    defaultLang: {
      type: String,
      default: ''
    },
    prodChnl: {
      type: String,
      default: ''
    }
  },
  emits: ['changeDefaultLang', 'setProdId'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const route = useRoute();
    const items = ref([]);
    const activeDefaultLang = ref(props.defaultLang); // 当前生效的默认语言，即第一行语言
    const langInfoList = ref([]); // 语言接口原始数据
    const loading = ref(false);
    const translateSourceIndex = ref(0); // 当前翻译的源语言索引
    const langOptions = computed(() => langInfoList.value.map(item => ({
      label: item.langName,
      value: item.lang
    })));
    const langValToItem = computed(() => {
      const map = {};
      langOptions.value.forEach(item => {
        map[item.value] = item;
      });
      return map;
    });
    const ENGLISH_LANG_REG = /^en([-_]|$)/i; // en / en-US / en_US 都算英语
    const isSupportedLang = lang => !!lang && !!langValToItem.value[lang];
    const resolveDefaultLang = () => {
      if (!langInfoList.value.length) return '';
      // 当前默认语言优先，其次英语，最后兜底列表首项
      if (isSupportedLang(activeDefaultLang.value)) return activeDefaultLang.value;
      const englishItem = langInfoList.value.find(item => ENGLISH_LANG_REG.test(item.lang));
      return (englishItem === null || englishItem === void 0 ? void 0 : englishItem.lang) || langInfoList.value[0].lang;
    }; // 计算第一行应使用的语言
    const syncFirstLang = () => {
      if (!items.value.length || !langInfoList.value.length) return;
      if (isSupportedLang(items.value[0].lang)) return;
      items.value[0].lang = resolveDefaultLang();
    }; // 第一行语言为空或不在当前渠道语言列表内时重新落值
    const moveDefaultLangToFirst = () => {
      if (!isSupportedLang(activeDefaultLang.value) || items.value[0].lang === activeDefaultLang.value) return;
      const defaultLangIndex = items.value.findIndex(item => item.lang === activeDefaultLang.value);
      if (defaultLangIndex > 0) {
        const temp = items.value[0];
        items.value[0] = items.value[defaultLangIndex];
        items.value[defaultLangIndex] = temp;
      }
    }; // 详情回显时默认语言可能不在首位，这里纠正
    const syncActiveDefaultLang = () => {
      var _items$value$;
      const firstLang = ((_items$value$ = items.value[0]) === null || _items$value$ === void 0 ? void 0 : _items$value$.lang) || '';
      if (!firstLang || firstLang === activeDefaultLang.value) return;
      activeDefaultLang.value = firstLang;
      emits('changeDefaultLang', firstLang);
    }; // 第一行语言即默认语言，变化后回传给父组件一起提交
    const calcSelectOptions = () => {
      if (!items.value.length || !langOptions.value.length) return;
      moveDefaultLangToFirst();
      syncFirstLang();
      const chosenArray = items.value.map(item => item.lang); // 所有语言下拉框选中项组成的集合
      const returnArray = []; // 空的语言下拉框内容，等待重组
      langOptions.value.forEach(item => {
        if (!chosenArray.includes(item.value)) {
          returnArray.push(langValToItem.value[item.value]);
        }
      });
      items.value.forEach((item, ind) => {
        var _langValToItem$value$;
        if (!item.key) {
          item.key = Date.now() + ind;
        }
        item.langOptions = cloneDeep(returnArray);
        // 已经选中的语言，推入到下拉框头部
        if (item.lang && langValToItem.value[item.lang]) {
          item.langOptions.unshift(langValToItem.value[item.lang]);
        }
        item.langName = ((_langValToItem$value$ = langValToItem.value[item.lang]) === null || _langValToItem$value$ === void 0 ? void 0 : _langValToItem$value$.label) || item.langName;
      });
      syncActiveDefaultLang();
    }; // 计算语言下拉框可选项，筛掉已被其他行选中的语言
    const changeName = async ind => {
      var _langInfoList$value$f;
      const item = items.value[ind];
      item.prodName = (item.prodName || '').trim().replace(/\|/g, '').replace(/｜/g, '');
      if (ind !== 0) return;
      // 第一行商品名用于拼接内购ID，内购ID只收英文，非英语先翻译再抛给父组件
      if (!item.prodName || ENGLISH_LANG_REG.test(item.lang)) {
        emits('setProdId', item.prodName);
        return;
      }
      const targetLang = ((_langInfoList$value$f = langInfoList.value.find(langItem => ENGLISH_LANG_REG.test(langItem.lang))) === null || _langInfoList$value$f === void 0 ? void 0 : _langInfoList$value$f.lang) || 'en_Us';
      const [err, res] = await awaitWrap(translator({
        sourceLang: item.lang,
        sourceText: item.prodName,
        targetLang: [targetLang]
      }));
      if (err) {
        return;
      }
      if (res && res.code === OK) {
        var _res$data;
        emits('setProdId', ((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.translateList) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.translatedResult) || '');
      }
    }; // 过滤前后空格与竖线，并回传第一行商品名用于拼接内购ID
    const changeProdDescription = ind => {
      const item = items.value[ind];
      item.prodDescription = (item.prodDescription || '').trim().replace(/\|/g, '').replace(/｜/g, '');
    }; // 过滤前后空格与竖线
    const pushItem = debounce(() => {
      items.value.push({
        key: Date.now(),
        lang: '',
        langOptions: cloneDeep(langOptions.value),
        prodDescription: '',
        prodName: ''
      });
      calcSelectOptions();
    }, 40); // 新增一行语言
    const deleteItem = ind => {
      items.value.splice(ind, 1);
      calcSelectOptions();
    }; // 删除一行语言
    const getTranslate = async (isName = true, sourceIndex = 0) => {
      const sourceItem = items.value[sourceIndex];
      const targetLang = items.value.filter((item, index) => !!item.lang && index !== sourceIndex).map(item => item.lang);
      try {
        const [err, res] = await awaitWrap(translator({
          sourceLang: sourceItem.lang,
          sourceText: isName ? sourceItem.prodName : sourceItem.prodDescription,
          targetLang
        }));
        if (err) {
          return;
        }
        if (res && res.code === OK) {
          var _res$data2;
          (_res$data2 = res.data) === null || _res$data2 === void 0 || _res$data2.translateList.forEach(translated => {
            items.value.filter(item => item.lang === translated.lang).forEach(item => {
              if (isName) {
                item.prodName = translated.translatedResult;
              } else {
                item.prodDescription = translated.translatedResult;
              }
            });
          });
        }
      } catch (e) {}
    };
    const translateLang = async (sourceIndex = 0) => {
      translateSourceIndex.value = sourceIndex;
      const sourceItem = items.value[sourceIndex];
      const targetLang = items.value.filter((item, index) => !!item.lang && index !== sourceIndex).map(item => item.lang);
      if (!targetLang.length) return message.error('请选择要翻译的语言');
      if (!sourceItem.prodName || !sourceItem.prodDescription) return message.error('请先填写源语言商品名称和描述');
      loading.value = true;
      await getTranslate(true, sourceIndex);
      await getTranslate(false, sourceIndex);
      loading.value = false;
    }; // AI翻译
    const getLangOptions = async () => {
      var _route$query;
      const res = await queryLangOption({
        prodChnl: props.prodChnl || ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.prodChnl) || ''
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === OK) {
        langInfoList.value = res.data || [];
      }
    }; // 拉取当前渠道支持的语言列表
    watch(() => props.filterItems, n => {
      var _items$value$0$langOp;
      if (!n) return;
      items.value = n;
      if (!items.value.length) return;
      // 未加过key、没有下拉选项、或第一行语言不在当前渠道语言列表内时，重新计算
      if (!items.value[0].key || !((_items$value$0$langOp = items.value[0].langOptions) !== null && _items$value$0$langOp !== void 0 && _items$value$0$langOp.length) || !isSupportedLang(items.value[0].lang)) {
        calcSelectOptions();
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(() => props.defaultLang, n => {
      // 父组件回写的是组件自己抛上去的值时不再处理，避免来回覆盖
      if (!n || n === activeDefaultLang.value) return;
      activeDefaultLang.value = n;
      if (!items.value.length || !langInfoList.value.length) return;
      // 交给 calcSelectOptions 处理：已配置该语言就换到首位，没有才落值，避免覆盖已填内容
      calcSelectOptions();
    });
    const getLanguageInfo = async lang => {
      if (!langInfoList.value.length) {
        await getLangOptions();
      }
      return langInfoList.value.find(item => item.lang === lang);
    };
    onMounted(async () => {
      try {
        await getLangOptions();
        calcSelectOptions();
      } catch (error) {}
    });
    expose({
      refreshLanguageOptions: calcSelectOptions,
      getLanguageInfo,
      getSupportedLangs: () => langInfoList.value.map(item => item.lang),
      isSupportedLang
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, ind) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          class: "item"
        }, [_createVNode(_component_a_select, {
          class: "selecter",
          disabled: props.disabled,
          value: item.lang,
          "onUpdate:value": $event => item.lang = $event,
          options: item.langOptions,
          placeholder: "请选择语言",
          onChange: calcSelectOptions,
          getPopupContainer: _unref(getNode),
          "show-search": "",
          "filter-option": _unref(filterOption)
        }, null, 8, ["disabled", "value", "onUpdate:value", "options", "getPopupContainer", "filter-option"]), _createVNode(_component_a_input, {
          class: "selecter ml8",
          disabled: props.disabled,
          value: item.prodName,
          "onUpdate:value": $event => item.prodName = $event,
          placeholder: props.nameRule.placeholder,
          onBlur: $event => changeName(ind)
        }, null, 8, ["disabled", "value", "onUpdate:value", "placeholder", "onBlur"]), _createVNode(_component_a_input, {
          class: "selecter bigInput ml8",
          disabled: props.disabled,
          value: item.prodDescription,
          "onUpdate:value": $event => item.prodDescription = $event,
          valueModifiers: {
            trim: true
          },
          placeholder: props.desRule.placeholder,
          onBlur: $event => changeProdDescription(ind)
        }, null, 8, ["disabled", "value", "onUpdate:value", "placeholder", "onBlur"]), !props.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_3, [ind === 0 ? _withDirectives((_openBlock(), _createBlock(_unref(PlusCircleOutlined), {
          key: 0,
          class: "plus-btn",
          onClick: _unref(pushItem)
        }, null, 8, ["onClick"])), [[_vShow, items.value.length < _unref(langOptions).length]]) : (_openBlock(), _createBlock(_component_svg_icon, {
          key: 1,
          "icon-class": "del",
          "class-name": "trash-btn hover-show",
          onClick: $event => deleteItem(ind)
        }, null, 8, ["onClick"])), items.value.length > 1 ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 2,
          class: "hover-show",
          title: "可将当前语言商品信息自动翻译成多语言，翻译结果仅供参考，如不满意可自行修改"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            loading: loading.value && translateSourceIndex.value === ind,
            disabled: props.disabled,
            class: "ai-translate-btn",
            onClick: $event => translateLang(ind)
          }, {
            icon: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "spark",
              "class-name": "sparkle-icon"
            })]),
            default: _withCtx(() => [_createTextVNode(" AI翻译 ")]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.error ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.error), 1)) : _createCommentVNode("", true)]);
      }), 128))])]);
    };
  }
});